import { addDays, format } from "date-fns";
import { toZonedTime } from "date-fns-tz";

const TZ = "America/Mexico_City";

/**
 * Fecha calendario mínima y máxima (CDMX): desde mañana hasta hoy+7 días.
 * No se permite agendar el mismo día (regla alineada con la API).
 */
export function getMxBookingBounds() {
  const mx = toZonedTime(new Date(), TZ);
  const minStr = format(addDays(mx, 1), "yyyy-MM-dd");
  const maxStr = format(addDays(mx, 7), "yyyy-MM-dd");
  return {
    minStr,
    maxStr,
    minDate: parseYmdAsLocalNoon(minStr),
    maxDate: parseYmdAsLocalNoon(maxStr),
  };
}

/**
 * Interpreta YYYY-MM-DD como día civil estable para el calendario (mediodía local evita saltos DST).
 */
export function parseYmdAsLocalNoon(ymd) {
  const [y, m, d] = ymd.split("-").map(Number);
  return new Date(y, m - 1, d, 12, 0, 0, 0);
}

export function dateToYmd(date) {
  if (!date) return "";
  const y = date.getFullYear();
  const mo = String(date.getMonth() + 1).padStart(2, "0");
  const da = String(date.getDate()).padStart(2, "0");
  return `${y}-${mo}-${da}`;
}
